<template>
  <div class="audio-controls">
    <button 
      class="audio-btn mic-btn" 
      @click="toggleMic" 
      :class="{ 'muted': isMuted }"
      :disabled="disabled"
    >
      <i :class="isMuted ? 'fas fa-microphone-slash' : 'fas fa-microphone'"></i>
    </button>
    
    <div class="volume-indicator" v-if="showVolumeIndicator">
      <div class="volume-bar" :style="{ width: `${volumeLevel}%` }"></div>
    </div>
    
    <div class="audio-status" v-if="showStatus">
      {{ statusText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AudioControls',
  props: {
    isMuted: {
      type: Boolean,
      default: false
    },
    volumeLevel: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showVolumeIndicator: {
      type: Boolean,
      default: true
    },
    showStatus: {
      type: Boolean,
      default: false
    },
    statusText: {
      type: String,
      default: ''
    }
  },
  methods: {
    toggleMic() {
      if (!this.disabled) {
        this.$emit('toggle-mic');
      }
    }
  }
}
</script>

<style scoped>
.audio-controls {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.audio-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  background-color: var(--primary-color, #4361ee);
  color: white;
}

.audio-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.audio-btn.muted {
  background-color: var(--danger-color, #e74c3c);
}

.volume-indicator {
  width: 100px;
  height: 6px;
  background-color: var(--border-color, rgba(203, 213, 225, 0.5));
  border-radius: 3px;
  overflow: hidden;
}

.volume-bar {
  height: 100%;
  background-color: var(--success-color, #2ecc71);
  transition: width 0.1s ease-out;
}

.audio-status {
  font-size: 0.875rem;
  color: var(--text-secondary, #64748b);
}

/* 暗色主题支持 */
[data-theme="dark"] .volume-indicator {
  background-color: var(--border-color, rgba(75, 85, 99, 0.5));
}

[data-theme="dark"] .audio-status {
  color: var(--text-secondary, #9ca3af);
}
</style> 